export enum SentBriefingEnum {
    dateSent,
    subjectLine,
    fromName,
    replyTo,
    mailingLists,
    recipients,
    reservedUrl,
    urlExpiryDate,
    rssFeeds
}
